import { idProp, model, Model, prop } from '../../mobx-weavix';

@model('Craft')
export class Craft extends Model({
    id: idProp,
    meshId: prop<number>(),
    accountId: prop<string>(),
    name: prop<string>(),
    code: prop<string>(),
    color: prop<string>(),
    tags: prop<string[]>(),
    disabled: prop<boolean>(),
}) {
}
